// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"1786":"css/app.7092","8527":"css/admin-app.7092"}[chunkId] + ".css";
};